"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACHMENTS_TAG_REGEX = void 0;
/** Matches the `<ATTACHMENTS>[...]</ATTACHMENTS>` tag in message content (non-global). */
exports.ATTACHMENTS_TAG_REGEX = /<ATTACHMENTS>(\[[\s\S]*?\])<\/ATTACHMENTS>/;
